module.exports = __webpack_public_path__ + "static/media/another-view.f55be7ee.png";